module.exports = __webpack_public_path__ + "static/media/pdf.b5c72120.png";